function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

let PACK_SELECTION = {};

let packItems = []

let total_quantity_global = false;

const passedIds = new Set();
for (let item of bundleData.bundle_products) {
    const variantId = item.variants[0].id;

    if (!passedIds.has(variantId)) {
        const newItem = {
            id: variantId,
            productId: item.id,
            handle: item.handle,
            title: item.title,
            quantity: 0
        };
        packItems.push(newItem);
        passedIds.add(variantId);
    }
}

class ProductTemplate extends HTMLElement {
    constructor() {
        super();

        this.querySelector('.product-form__submit').addEventListener('click', this.submitForm.bind(this));
        this.initEvents();

        this.querySelectorAll('[data-abo-recharge]').forEach((elem) => {
            elem.addEventListener('click', this.setRecurrence.bind(this))
        })

        this.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.addEventListener('click', this.updateCollectionContent.bind(this))
        })

        this.calculateShipping();

        this.all_packs_container = document.querySelectorAll("pack-item");
        this.last_number_selection = 0;
        this.first_load = true;
        this.content_updated = false;

        let parent = document.querySelector('.product-form__submit').parentElement;

        while (parent) {
            const hasOverflow = getComputedStyle(parent).overflow;
            if (hasOverflow !== 'visible') {
                console.log(hasOverflow, parent);
            }
            parent = parent.parentElement;
        }

    }

    updateCollectionContent(e) {
        let current = e.currentTarget;
        let collection_id = current.dataset.handle;

        document.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.classList.remove('actif');
        })

        current.classList.add('actif');

        document.querySelectorAll('.product-form__product-item').forEach((elem) => {
            elem.classList.add('hidden');
        })

        // if product-form__product-item data-handle contain the collection_id we remove the hidden class

        document.querySelectorAll(`.product-form__product-item`).forEach((elem) => {
            let elem_collection_id = elem.dataset.handle.split(' , ');
            console.log(elem_collection_id);

            if (elem_collection_id.includes(collection_id)) {
                elem.classList.remove('hidden');
            }
        }
        )


    }

    calculateShipping() {
        if (this.querySelector('.product-form__icon')) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(this.getAttribute('data-shipping-delay'));


            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            for (let i = 0; i < document.querySelectorAll('.product-form__icon').length; i++) {
                let html = document.querySelectorAll('.product-form__icon')[i].innerHTML;
                if (html.indexOf('[date]') > -1) {
                    document.querySelectorAll('.product-form__icon')[i].innerHTML = html.replace('[date]', shipping_date_format);
                }
            }
        }
    }

    setRecurrence(e) {
        let current = e.currentTarget;

        if (current.classList.contains('abos__one-shoot')) {
            this.querySelector('.abos__abo').classList.remove('active');
            current.classList.add('active');
        }
        else {

            this.querySelector('.abos__one-shoot').classList.remove('active');
            current.classList.add('active');

        }
    }

    setSellingPlan(e) {
        document.querySelector('.rb-frequency-wrapper [data-selling-plan-id="0"]').selected = true;
        document.querySelector('#selling-plan-list').dispatchEvent(new Event("change"));
    }

    async submitForm() {
        document.querySelectorAll('[submit-button-effect]').forEach((elem) => {
            elem.classList.add('active');
        })

        let selections_items = []

        let content_pack = ''

        let packs__quantity = 0;

        for (const item of PACK_SELECTION.pack_items) {
            packs__quantity += item.quantity;
        }

        if (total_quantity_global == false) {
            let reste = PACK_SELECTION.coffee_times - packs__quantity;
            document.querySelector('.error__content').textContent = reste
            document.querySelector(".selection-packs-error").classList.add("open");
            return;
        } else {
            for (const item of PACK_SELECTION.pack_items) {
                if (item.quantity > 0) {
                    selections_items.push(
                        {
                            externalProductId: `${item.productId}`,
                            externalVariantId: `${item.id}`,
                            collectionId: `631449420100`,
                            quantity: item.quantity
                        }
                    )
                    let quantity_flavor = item.quantity;
                    content_pack += (`${quantity_flavor}x ${item.title}`) + " ";
                }
            }


            let content_pack_custom = (`${PACK_SELECTION.nb_opercule}`) + " opercules";
            console.log(selections_items);
            console.log(PACK_SELECTION.pack_id, PACK_SELECTION.pack_variant_id);

            const bundle = {
                externalProductId: `${PACK_SELECTION.pack_id}`, // Bundle's Shopify Product ID
                externalVariantId: `${PACK_SELECTION.pack_variant_id}`, // Bundle's Shopify Variant ID
                selections:
                    selections_items
            };


            const isValid = await recharge.bundle.validateBundle(bundle);
            console.log(isValid);
            console.log(bundle);


            if (isValid === true) {
                let rbId = await recharge.bundle.getBundleId(bundle);
                if (rbId) {
                    //  fetch add to cart the current product on PACK_SELECTION
                    let url = window.location.origin + "/cart/add.js";
                    let data = {};
                    if (document.querySelector('.product-form__variant-items')) {
                        data = {
                            items: [
                                {
                                    id: PACK_SELECTION.pack_variant_id,
                                    quantity: 1,
                                    selling_plan: null,
                                    properties: {
                                        Compostion: content_pack,
                                        _rb_id: rbId,
                                    }
                                },
                                {
                                    id: Number(document.querySelector('.product-form__variant-item.active .product-form__variant-item--current.active').dataset.currentVariant),
                                    quantity: 1,
                                }
                            ]
                        };
                    } else {
                        data = {
                            items: [
                                {
                                    id: PACK_SELECTION.pack_variant_id,
                                    quantity: 1,
                                    selling_plan: null,
                                    properties: {
                                        Compostion: content_pack,
                                        _rb_id: rbId,
                                    }
                                },
                                {
                                    id: PACK_SELECTION.customVariantGiftId,
                                    quantity: 1,
                                },
                                {
                                    id: PACK_SELECTION.customVariantId,
                                    quantity: 1
                                }
                            ]
                        };
                    }



                    console.log(data.items[0].properties.Contents);
                    console.log(data.items[0].pack_name);

                    if (data.items[0].properties.Contents != "") {

                        fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(data),
                        })
                            .then((response) => {
                                return response.json();
                            })
                            .then((data) => {
                                // add event submit on shopify-product-form to open the cart (tricks)
                                console.log(data);

                                let _item = {
                                    Name: data.items[0].pack_name,
                                    ProductID: data.items[0].variant_id,
                                    Categories: [data.items[0].product_title],
                                    ImageURL: data.items[0].featured_image.url,
                                    URL: data.items[0].url,
                                    Brand: data.items[0].vendor,
                                    Price: Number(data.items[0].price / 100).toFixed(2) + "€",
                                    CompareAtPrice: typeof(CompareAtPrice) !== 'undefined' ? CompareAtPrice : '',
                                };

                                _learnq.push(["track", "Added to Cart", _item]);
                                document.querySelector('side-cart').refreshCart()
                            });
                    }
                }

            } else {
            }

        }
    }

    // submitForm(event) {
    //     event.preventDefault();

    //     // We get the total quantity of coffees in the pack
    //     let total = 0;
    //     for (const item of PACK_SELECTION.pack_items) {
    //         total += item.quantity;
    //     }

    //     if (total === PACK_SELECTION.coffee_times) {

    //         document.querySelector(".product-form__submit").classList.add("loading");

    //         this.setSellingPlan();

    //         // Update bundle size on recharge widget
    //         const bundle_size_select = document
    //             .querySelector(`#recharge-bundles #product-variant-list`)
    //         bundle_size_select.value = `${PACK_SELECTION.pack_name}`;
    //         bundle_size_select.dispatchEvent(new Event("change"));

    //         for (const item of PACK_SELECTION.pack_items) {
    //             // Set the variant size on recharge widget
    //             const id = item.title;
    //             const select_recharge = document
    //                 .querySelector(`.rb-item-actions [name="${id}"]`);
    //             console.log(id);
    //             select_recharge.value = item.quantity;
    //             select_recharge.dispatchEvent(new Event("change"));
    //         }

    //         setTimeout(this.submitBundle.bind(this), 400);

    //     } else {

    //         let reste = PACK_SELECTION.coffee_times - total;
    //         document.querySelector('.error__content').textContent = reste
    //         document.querySelector(".selection-packs-error").classList.add("open");

    //     }

    // }

    submitBundle() {
        const submitBtn = document.querySelector(".rb-container form button");
        submitBtn.click();
        document.querySelector(".product-form__submit").classList.remove("loading");
    }

    initEvents() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.querySelectorAll('[data-open-modal-product]').forEach((elem) => {
            elem.addEventListener('click', this.openProductModal.bind(this))
        })

        document
            .querySelectorAll(".selection-packs-upgrade__decline")
            .forEach((button) => {
                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".selection-packs-upgrade")
                        .forEach((item) => {
                            item.classList.remove("open");
                        });
                });
            });
    }

    openProductModal(e) {
        const itemId = e.currentTarget.getAttribute('data-product-modal-id')

        let display = this.dataset.popUp

        fetch(`/products/${itemId}?view=${display}`)
            .then((data) => {
                console.log(data);
                return data.text()
            })
            .then((html) => {
                console.log(html);
                const modal = document.querySelector('.product-modal')
                modal.innerHTML = html;
                modal.classList.add('actif')
                document.addEventListener(
                    "click",
                    function (e) {
                        if (
                            !e.target.closest("[data-open-modal-product]") &&
                            !e.target.closest(".product-modal")
                        ) {
                            this.closeModal();
                        }
                    }.bind(this)
                );
                
                modal.querySelector('.close-modal').addEventListener('click', this.closeModal.bind(this))
                document.querySelector('html').classList.add('overflow-hidden')

                const sliderTouch = document.querySelectorAll(".scroll-touch");
                let isDown = false;
                let startX;
                let scrollLeft;

                for (let slider of sliderTouch) {
                    slider.addEventListener("mousedown", e => {
                        isDown = true;
                        slider.classList.add("active");
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                    });
                    slider.addEventListener("mouseleave", () => {
                        isDown = false;
                        slider.classList.remove("active");
                        blockedLinks(isDown);
                    });
                    slider.addEventListener("mouseup", () => {
                        isDown = false;
                        slider.classList.remove("active");
                        blockedLinks(isDown);
                    });
                    slider.addEventListener("mousemove", e => {
                        if (!isDown) return;
                        e.preventDefault();
                        blockedLinks(isDown);
                        const x = e.pageX - slider.offsetLeft;
                        const walk = x - startX;
                        slider.scrollLeft = scrollLeft - walk;
                    });
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    closeModal() {
        const modal = document.querySelector('.product-modal')
        modal.classList.remove('actif')
        document.querySelector('html').classList.remove('overflow-hidden')
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', ProductTemplate);

window.addEventListener('load', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});
window.addEventListener('resize', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});

class VariantItem extends HTMLElement {
    constructor() {
        super();

        this.updatePackContent()
        this.addEventListener('click', this.toggleVariant.bind(this));
    }

    toggleVariant() {
        if (this.classList.contains('disabled')) {
            return;
        }
        document.querySelectorAll('variant-item').forEach((item) => {
            item.classList.remove('active');
        });
        this.changeUrl();
        this.classList.add('active');
        this.updatePackContent();
    }


    changeUrl() {
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}`
        )
    }

    updatePackContent() {

        if (this.classList.contains("active")) {
            // We update the pack selection object
            PACK_SELECTION = {
                subtitle: this.dataset.productSubtitle,
                pack_id: parseInt(this.dataset.productId),
                pack_variant_id: parseInt(this.dataset.productVariantId),
                pack_name: this.dataset.productName,
                pack_price: parseFloat(this.dataset.productVariantPrice),
                pack_price_sub: parseFloat(this.dataset.productVariantPriceSub),
                variant_price: parseFloat(this.dataset.productCompareVariantPrice),
                reduction: parseInt(this.dataset.productReduction),
                coffee_times: parseInt(this.dataset.coffeeTimes),
                pack_image: this.dataset.productImage,
                pack_items: PACK_SELECTION.pack_items ? PACK_SELECTION.pack_items : packItems,
                nb_opercule: parseInt(this.dataset.nbOpercule),
                customProductId: parseInt(this.dataset.customProductId),
                customVariantId: parseInt(this.dataset.customVariantId),
                customVariantGiftId: parseInt(this.dataset.customVariantGift),
            };

            if (PACK_SELECTION.pack_items) {
                let total = 0;
                for (const item of PACK_SELECTION.pack_items) {
                    total += item.quantity;
                }

                let reste = PACK_SELECTION.coffee_times - total;

                document.querySelector('[data-rest-coffee]').textContent = reste;

                if (total >= PACK_SELECTION.coffee_times) {
                    total_quantity_global = true;
                    document.querySelector('.product-form__rest-content').classList.add('hidden');
                }
                else {
                    total_quantity_global = false;
                    document.querySelector('.product-form__rest-content').classList.remove('hidden');
                }

                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (total > PACK_SELECTION.coffee_times) {
                    for (const item of PACK_SELECTION.pack_items) {
                        item.quantity = 0;
                    }

                    total_quantity_global = false;

                    document.querySelectorAll('quantity-input .product-count').forEach((input) => {
                        input.value = 0;
                    })

                    document.querySelector('[data-rest-coffee]').textContent = PACK_SELECTION.coffee_times;

                    document.querySelectorAll('.product--quantity__init').forEach((elem) => {
                        elem.classList.remove('hidden');
                    })

                    document.querySelector('.product-form__content-items').classList.add('hidden');

                    document.querySelector('[data-nb-pack]').textContent = 0;

                    document.querySelector('.product-form__rest-content').classList.remove('hidden');
                }
            }

            if (document.querySelector('.product-form__variant-item')) {
                document.querySelectorAll('.product-form__variant-item--product').forEach((elem) => {
                    elem.addEventListener('click', (e) => {
                        elem.closest('[data-gift-id]').querySelectorAll('.product-form__variant-item--product').forEach((elem) => {
                            elem.classList.remove('active');
                        })
                        elem.classList.add('active');
                        document.querySelector('[current-boite-title]').textContent = elem.dataset.variantTitle;
                    })
                })

                document.querySelectorAll('.product-form__variant-item--variant').forEach((elem) => {
                    elem.addEventListener('click', (e) => {
                        elem.closest('[data-gift-id]').querySelectorAll('.product-form__variant-item--variant').forEach((elem) => {
                            elem.classList.remove('active');
                        })
                        elem.classList.add('active');
                    })
                })
            }

            // this.updatePriceCta();
            this.updatePageContent();
            this.updatePrices();
        }
    }

    updatePageContent() {
        if (PACK_SELECTION) {
            document.querySelector('.product-form--steps-nbItems').textContent = PACK_SELECTION.coffee_times;
            document.querySelector('[data_nb_pack]').textContent = PACK_SELECTION.coffee_times;
            if (document.querySelector('[data_nb_opercules]')) {
                document.querySelector('[data_nb_opercules]').textContent = PACK_SELECTION.nb_opercule;
            }

            document.querySelectorAll('.product-form__pack--compo-item.free-item').forEach((elem) => {
                elem.classList.add('hidden');
            })

            document.querySelectorAll('.product-form__variant-item[data-gift-id]').forEach((elem) => {
                elem.classList.remove('active');
            })

            document.querySelector(`.product-form__pack--compo-item[data-gift-id="${PACK_SELECTION.pack_variant_id}"]`).classList.remove('hidden');
            if (document.querySelector(`.product-form__variant-item[data-gift-id]`)) {
                document.querySelector(`.product-form__variant-item[data-gift-id="${PACK_SELECTION.pack_variant_id}"]`).classList.add('active');
            }

            // Check if the active free-item is disabled and update submit button
            const activeFreeItem = document.querySelector(`.product-form__pack--compo-item.free-item[data-gift-id="${PACK_SELECTION.pack_variant_id}"]`);
            const submitButton = document.querySelector('.product-form__submit');
            if (activeFreeItem && activeFreeItem.classList.contains('disabled')) {
                submitButton.classList.add('disabled');
            } else {
                submitButton.classList.remove('disabled');
            }
        }

        //  change source image to show the pack selection

        document.querySelectorAll('.product-media__item--image').forEach((elem) => {
            elem.parentNode.classList.add('hidden');
        })

        document.querySelector(`#image-${PACK_SELECTION.pack_variant_id}`).parentNode.classList.remove('hidden');

        if (PACK_SELECTION.reduction == 0) {
            document.querySelectorAll('.multiple-items').forEach((elem) => {
                elem.style.display = 'none'
            })
            document.querySelector('.product-media__item .product-media__tag').classList.add('hidden')

        } else {
            document.querySelectorAll('.multiple-items').forEach((elem) => {
                elem.style.display = 'inline-block'
            })

            document.querySelector('.product-media__item .product-media__tag').textContent = PACK_SELECTION.pack_name;
            document.querySelector('.product-media__item .product-media__tag').classList.remove('hidden');

        }
    }

    updatePrices() {
        console.log(PACK_SELECTION);

        let prices = document.querySelectorAll('[data-price]');
        let compare_prices = document.querySelectorAll('[data-compare-at-price]');
        console.log(compare_prices);
        console.log(PACK_SELECTION);
        for (const price of prices) {
            price.textContent = PACK_SELECTION.pack_price.toFixed(2) + '€';
        }

        for (const compare_price of compare_prices) {
            compare_price.textContent = PACK_SELECTION.variant_price.toFixed(2) + '€';
        }

    }
}

customElements.define('variant-item', VariantItem);

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.addEventListener("click", this.changeQuantity.bind(this));
        this.addEventListener("updateContent", this.changeQuantity.bind(this));

        this.querySelector('.product--quantity__init').addEventListener('click', function () {
            if (this.querySelector('.product--quantity__init').classList.contains('disabled')) {
                return;
            }
            this.querySelector('[data-action="increment"]').click();
            this.querySelector('.product--quantity__init').classList.add('hidden');
        }.bind(this));


        this.updatecoffeesCounter();

    }

    changeQuantity(event) {

        let target = event.target;
        let total = 0;

        // Get the total quantity of coffees in the pack
        for (const item of PACK_SELECTION.pack_items) {
            total += item.quantity;
        }

        console.log(total, PACK_SELECTION.coffee_times);

        const value = parseInt(this.input.value);

        if (target.classList.contains("quantity-input__btn")) {
            if (target.dataset.action === "increment") {
                if (total < PACK_SELECTION.coffee_times) {
                    target
                        .closest("quantity-input")
                        .querySelector('[data-action="decrement"]')
                        .removeAttribute("disabled");
                    // We update the input value with the new quantity
                    this.input.value = parseInt(value) + 1;
                    if (this.input.value == this.input.max) {
                        this.parentNode.classList.add('out-of-stock-dinamique');
                    }
                } else {
                    document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                        elem.setAttribute("disabled", "true");
                    });
                }
            } else if (target.dataset.action === "decrement") {
                this.parentNode.classList.remove('out-of-stock-dinamique');
                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (value > 0) {
                    this.input.value = parseInt(value) - 1;
                    // We update the input value with the new quantity
                    if (this.input.value == 0) {
                        target.setAttribute("disabled", "disabled");
                    }

                } else {
                }
            }
        }

        let total_coffees = 0;

        if (this.input.value == 0) {
            this.querySelector('.product--quantity__init').classList.remove('hidden');
        }

        let quantity_inputs = document.querySelectorAll(
            '.product-form__product-item quantity-input [name="quantity"][data-handle]'
        );

        for (const input of quantity_inputs) {
            total_coffees += parseInt(input.value);
        }

        if (total_coffees === 0) {
            document.querySelector('.product-form__content-items').classList.add('hidden');
        }

        document.querySelector('[data-nb-pack]').textContent = total_coffees;

        let reste = PACK_SELECTION.coffee_times - total_coffees;

        document.querySelector('[data-rest-coffee]').textContent = reste;


        if (total_coffees === PACK_SELECTION.coffee_times) {
            total_quantity_global = true;
            document.querySelector('.product-form__rest-content').classList.add('hidden');
        } else {
            total_quantity_global = false;
            document.querySelector('.product-form__rest-content').classList.remove('hidden');
        }

        this.updateSelectionContent();
        this.updatecoffeesCounter();
    }



    updatecoffeesCounter() { }

    updateSelectionContent() {

        console.log('change quantity');
        const quantity_inputs = document.querySelectorAll(
            ".product-form__product-item quantity-input"
        );
        for (const input of quantity_inputs) {
            for (let item of PACK_SELECTION.pack_items) {
                // Update the quantity of each smoothie in the pack selection object
                if (item.handle === input.querySelector("input").dataset.handle) {
                    item.quantity = parseInt(input.querySelector("input").value);
                    console.log(item);
                }
            }
        }
        let index = 0;
        let content_pack = document.querySelector("[data-pack-content]").textContent;
        content_pack = '';
        let content_updated = '';

        console.log(PACK_SELECTION.pack_items);

        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity > 0) {
                console.log(item.title);
                document.querySelector('.product-form__content-items').classList.remove('hidden');
                if (index == 0) {
                    content_updated += (`${item.title} (${item.quantity})`);
                }
                else {
                    content_updated += (`, ${item.title} (${item.quantity})`);
                }
                index++;
            }
        }

        document.querySelector("[data-pack-content]").textContent = content_updated;
    }
}

if (customElements.get("quantity-input") === undefined) {
    customElements.define("quantity-input", QuantityInput);
}


const disabledLinks = (urls, attr, setAttr) => {
    [...urls].forEach(url => {
        url.setAttribute(attr, setAttr)
    })
}

const blockedLinks = (down) => {
    const allLinks = document.querySelectorAll('.url-card');
    down
        ? disabledLinks(allLinks, 'disabled', 'disabled')
        : disabledLinks(allLinks, 'disabled', '')
}


